interface ApiErrorLike {
  response?: { data?: { message?: string } };
}

/** Backend `message` of an axios-like error, if it carries one. */
export const apiErrorMessage = (error: unknown): string | undefined =>
  (error as ApiErrorLike | undefined)?.response?.data?.message;
